import {createSlice} from '@reduxjs/toolkit'

import {
  AuthenticationFlows,
  SourceComponentType
} from '@vio/core/src/auth/types/Auth'

import type {PayloadAction} from '@reduxjs/toolkit'

interface EmailSignUpState {
  isOpen: boolean
  isEmailVerified: boolean
  sourceComponent?: SourceComponentType | null
  flow?: AuthenticationFlows | null
  analyticsData?: Record<string, unknown>
}

const initialState = {
  isOpen: false,
  sourceComponent: null
} as EmailSignUpState

const {actions, reducer} = createSlice({
  name: 'emailSignUp',
  initialState,
  reducers: {
    setEmailSignUpVisibility(
      state,
      action: PayloadAction<{
        isOpen: boolean
        sourceComponent?: SourceComponentType | null
        flow?: AuthenticationFlows | null
        analyticsData?: Record<string, unknown>
      }>
    ) {
      state.isOpen = action.payload.isOpen
      state.sourceComponent = action.payload?.sourceComponent
      state.flow = action.payload?.flow
      state.analyticsData = action.payload?.analyticsData
    }
  }
})

export default reducer

export const {setEmailSignUpVisibility} = actions
